"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "NativeToolbarSpacer", {
    enumerable: true,
    get: function() {
        return NativeToolbarSpacer;
    }
});
const NativeToolbarSpacer = ()=>null;

//# sourceMappingURL=native.js.map
